/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as PluginsOutlookRouteImport } from './routes/plugins/outlook'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedProcessesRouteImport } from './routes/_authenticated/processes'
import { Route as AuthenticatedModelsRouteImport } from './routes/_authenticated/models'
import { Route as AuthenticatedMessagesRouteImport } from './routes/_authenticated/messages'
import { Route as AuthenticatedIntegrationsRouteImport } from './routes/_authenticated/integrations'
import { Route as AuthenticatedFlowsRouteImport } from './routes/_authenticated/flows'
import { Route as AuthenticatedAutomationsRouteImport } from './routes/_authenticated/automations'
import { Route as AuthenticatedAppsRouteImport } from './routes/_authenticated/apps'
import { Route as AuthenticatedAnalyticsRouteImport } from './routes/_authenticated/analytics'
import { Route as AuthVerifyEmailRouteImport } from './routes/_auth/verify-email'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as AuthNoOrgRouteImport } from './routes/_auth/no-org'
import { Route as AuthNoMemberRouteImport } from './routes/_auth/no-member'
import { Route as AuthNoAccessRouteImport } from './routes/_auth/no-access'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthLinkAccountRouteImport } from './routes/_auth/link-account'
import { Route as AuthEnableMfaRouteImport } from './routes/_auth/enable-mfa'
import { Route as AuthAuthErrorRouteImport } from './routes/_auth/auth-error'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedProcessesIndexRouteImport } from './routes/_authenticated/processes.index'
import { Route as AuthenticatedModelsIndexRouteImport } from './routes/_authenticated/models.index'
import { Route as AuthenticatedIntegrationsIndexRouteImport } from './routes/_authenticated/integrations.index'
import { Route as AuthenticatedAutomationsIndexRouteImport } from './routes/_authenticated/automations.index'
import { Route as AuthenticatedAppsIndexRouteImport } from './routes/_authenticated/apps.index'
import { Route as AuthenticatedAnalyticsIndexRouteImport } from './routes/_authenticated/analytics.index'
import { Route as PluginsOutlookTaskpaneRouteImport } from './routes/plugins/outlook/taskpane'
import { Route as PluginsOutlookDialogRouteImport } from './routes/plugins/outlook/dialog'
import { Route as PluginsOutlookOutlookAuthRouteImport } from './routes/plugins/outlook/_outlookAuth'
import { Route as AuthenticatedTestHooksUseQueryParamsRouteImport } from './routes/_authenticated/test-hooks.useQueryParams'
import { Route as AuthenticatedSettingsUsersRouteImport } from './routes/_authenticated/settings/users'
import { Route as AuthenticatedSettingsSsoRouteImport } from './routes/_authenticated/settings/sso'
import { Route as AuthenticatedSettingsSecurityRouteImport } from './routes/_authenticated/settings/security'
import { Route as AuthenticatedSettingsOrganizationRouteImport } from './routes/_authenticated/settings/organization'
import { Route as AuthenticatedSettingsAuditLogsRouteImport } from './routes/_authenticated/settings/audit-logs'
import { Route as AuthenticatedSettingsApikeysRouteImport } from './routes/_authenticated/settings/apikeys'
import { Route as AuthenticatedSettingsAccountRouteImport } from './routes/_authenticated/settings/account'
import { Route as AuthenticatedProcessesProcessIdRouteImport } from './routes/_authenticated/processes.$processId'
import { Route as AuthenticatedModelsModelIdRouteImport } from './routes/_authenticated/models.$modelId'
import { Route as AuthenticatedIntegrationsBrowseRouteImport } from './routes/_authenticated/integrations.browse'
import { Route as AuthenticatedFlowsNewRouteImport } from './routes/_authenticated/flows.new'
import { Route as AuthenticatedFlowsListRouteImport } from './routes/_authenticated/flows._list'
import { Route as AuthenticatedFlowsFlowIdRouteImport } from './routes/_authenticated/flows.$flowId'
import { Route as AuthenticatedAutomationsTemplatesRouteImport } from './routes/_authenticated/automations.templates'
import { Route as AuthenticatedAutomationsCodeRouteImport } from './routes/_authenticated/automations.code'
import { Route as AuthenticatedAutomationsFlowIdRouteImport } from './routes/_authenticated/automations.$flowId'
import { Route as AuthenticatedAppsAppIdRouteImport } from './routes/_authenticated/apps.$appId'
import { Route as AuthenticatedAnalyticsTopicDiscoveryRouteImport } from './routes/_authenticated/analytics.topic-discovery'
import { Route as PluginsOutlookTaskpaneIndexRouteImport } from './routes/plugins/outlook/taskpane.index'
import { Route as AuthenticatedFlowsListIndexRouteImport } from './routes/_authenticated/flows._list.index'
import { Route as AuthenticatedAutomationsCodeIndexRouteImport } from './routes/_authenticated/automations.code.index'
import { Route as AuthenticatedAnalyticsTopicDiscoveryIndexRouteImport } from './routes/_authenticated/analytics.topic-discovery.index'
import { Route as PluginsOutlookTaskpaneShowFileRouteImport } from './routes/plugins/outlook/taskpane.show-file'
import { Route as PluginsOutlookOutlookAuthLoginRouteImport } from './routes/plugins/outlook/_outlookAuth/login'
import { Route as PluginsOutlookOutlookAuthAuthErrorRouteImport } from './routes/plugins/outlook/_outlookAuth/auth-error'
import { Route as PluginsOutlookOutlookAuthOutlookSetupRouteImport } from './routes/plugins/outlook/_outlookAuth/_outlookSetup'
import { Route as AuthenticatedModelsExtractionModelIdRouteImport } from './routes/_authenticated/models.extraction.$modelId'
import { Route as AuthenticatedModelsClassificationModelIdRouteImport } from './routes/_authenticated/models.classification.$modelId'
import { Route as AuthenticatedIntegrationsTypeSetupRouteImport } from './routes/_authenticated/integrations.$type.setup'
import { Route as AuthenticatedFlowsListTemplatesRouteImport } from './routes/_authenticated/flows._list.templates'
import { Route as AuthenticatedFlowsListCodeRouteImport } from './routes/_authenticated/flows._list.code'
import { Route as AuthenticatedAutomationsCodeNewRouteImport } from './routes/_authenticated/automations.code.new'
import { Route as AuthenticatedAutomationsCodeIdRouteImport } from './routes/_authenticated/automations.code.$id'
import { Route as AuthenticatedAnalyticsTopicDiscoveryTopicDiscoveryIdRouteImport } from './routes/_authenticated/analytics.topic-discovery.$topicDiscoveryId'
import { Route as PluginsOutlookOutlookAuthOutlookSetupVerifyEmailRouteImport } from './routes/plugins/outlook/_outlookAuth/_outlookSetup/verify-email'
import { Route as PluginsOutlookOutlookAuthOutlookSetupNoOrgRouteImport } from './routes/plugins/outlook/_outlookAuth/_outlookSetup/no-org'
import { Route as PluginsOutlookOutlookAuthOutlookSetupNoMemberRouteImport } from './routes/plugins/outlook/_outlookAuth/_outlookSetup/no-member'
import { Route as PluginsOutlookOutlookAuthOutlookSetupNoAccessRouteImport } from './routes/plugins/outlook/_outlookAuth/_outlookSetup/no-access'
import { Route as PluginsOutlookOutlookAuthOutlookSetupLinkAccountRouteImport } from './routes/plugins/outlook/_outlookAuth/_outlookSetup/link-account'
import { Route as PluginsOutlookOutlookAuthOutlookSetupEnableMfaRouteImport } from './routes/plugins/outlook/_outlookAuth/_outlookSetup/enable-mfa'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/index.lazy').then((d) => d.Route),
)
const PluginsOutlookRoute = PluginsOutlookRouteImport.update({
  id: '/plugins/outlook',
  path: '/plugins/outlook',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProcessesRoute = AuthenticatedProcessesRouteImport.update({
  id: '/processes',
  path: '/processes',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedModelsRoute = AuthenticatedModelsRouteImport.update({
  id: '/models',
  path: '/models',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMessagesRoute = AuthenticatedMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/messages.lazy').then((d) => d.Route),
)
const AuthenticatedIntegrationsRoute =
  AuthenticatedIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFlowsRoute = AuthenticatedFlowsRouteImport.update({
  id: '/flows',
  path: '/flows',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAutomationsRoute =
  AuthenticatedAutomationsRouteImport.update({
    id: '/automations',
    path: '/automations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppsRoute = AuthenticatedAppsRouteImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAnalyticsRoute = AuthenticatedAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthNoOrgRoute = AuthNoOrgRouteImport.update({
  id: '/no-org',
  path: '/no-org',
  getParentRoute: () => AuthRoute,
} as any)
const AuthNoMemberRoute = AuthNoMemberRouteImport.update({
  id: '/no-member',
  path: '/no-member',
  getParentRoute: () => AuthRoute,
} as any)
const AuthNoAccessRoute = AuthNoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLinkAccountRoute = AuthLinkAccountRouteImport.update({
  id: '/link-account',
  path: '/link-account',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEnableMfaRoute = AuthEnableMfaRouteImport.update({
  id: '/enable-mfa',
  path: '/enable-mfa',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthErrorRoute = AuthAuthErrorRouteImport.update({
  id: '/auth-error',
  path: '/auth-error',
  getParentRoute: () => AuthRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedProcessesIndexRoute =
  AuthenticatedProcessesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProcessesRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/processes.index.lazy').then((d) => d.Route),
  )
const AuthenticatedModelsIndexRoute =
  AuthenticatedModelsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedModelsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/models.index.lazy').then((d) => d.Route),
  )
const AuthenticatedIntegrationsIndexRoute =
  AuthenticatedIntegrationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedIntegrationsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/integrations.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAutomationsIndexRoute =
  AuthenticatedAutomationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAutomationsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/automations.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAppsIndexRoute = AuthenticatedAppsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAppsRoute,
} as any)
const AuthenticatedAnalyticsIndexRoute =
  AuthenticatedAnalyticsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAnalyticsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/analytics.index.lazy').then((d) => d.Route),
  )
const PluginsOutlookTaskpaneRoute = PluginsOutlookTaskpaneRouteImport.update({
  id: '/taskpane',
  path: '/taskpane',
  getParentRoute: () => PluginsOutlookRoute,
} as any)
const PluginsOutlookDialogRoute = PluginsOutlookDialogRouteImport.update({
  id: '/dialog',
  path: '/dialog',
  getParentRoute: () => PluginsOutlookRoute,
} as any)
const PluginsOutlookOutlookAuthRoute =
  PluginsOutlookOutlookAuthRouteImport.update({
    id: '/_outlookAuth',
    getParentRoute: () => PluginsOutlookRoute,
  } as any)
const AuthenticatedTestHooksUseQueryParamsRoute =
  AuthenticatedTestHooksUseQueryParamsRouteImport.update({
    id: '/test-hooks/useQueryParams',
    path: '/test-hooks/useQueryParams',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsUsersRoute =
  AuthenticatedSettingsUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/users.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsSsoRoute =
  AuthenticatedSettingsSsoRouteImport.update({
    id: '/sso',
    path: '/sso',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/sso.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsSecurityRoute =
  AuthenticatedSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/security.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsOrganizationRoute =
  AuthenticatedSettingsOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/organization.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsAuditLogsRoute =
  AuthenticatedSettingsAuditLogsRouteImport.update({
    id: '/audit-logs',
    path: '/audit-logs',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/audit-logs.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsApikeysRoute =
  AuthenticatedSettingsApikeysRouteImport.update({
    id: '/apikeys',
    path: '/apikeys',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/apikeys.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/account.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedProcessesProcessIdRoute =
  AuthenticatedProcessesProcessIdRouteImport.update({
    id: '/$processId',
    path: '/$processId',
    getParentRoute: () => AuthenticatedProcessesRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/processes.$processId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedModelsModelIdRoute =
  AuthenticatedModelsModelIdRouteImport.update({
    id: '/$modelId',
    path: '/$modelId',
    getParentRoute: () => AuthenticatedModelsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/models.$modelId.lazy').then((d) => d.Route),
  )
const AuthenticatedIntegrationsBrowseRoute =
  AuthenticatedIntegrationsBrowseRouteImport.update({
    id: '/browse',
    path: '/browse',
    getParentRoute: () => AuthenticatedIntegrationsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/integrations.browse.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedFlowsNewRoute = AuthenticatedFlowsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedFlowsRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/flows.new.lazy').then((d) => d.Route),
)
const AuthenticatedFlowsListRoute = AuthenticatedFlowsListRouteImport.update({
  id: '/_list',
  getParentRoute: () => AuthenticatedFlowsRoute,
} as any)
const AuthenticatedFlowsFlowIdRoute =
  AuthenticatedFlowsFlowIdRouteImport.update({
    id: '/$flowId',
    path: '/$flowId',
    getParentRoute: () => AuthenticatedFlowsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/flows.$flowId.lazy').then((d) => d.Route),
  )
const AuthenticatedAutomationsTemplatesRoute =
  AuthenticatedAutomationsTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => AuthenticatedAutomationsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/automations.templates.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAutomationsCodeRoute =
  AuthenticatedAutomationsCodeRouteImport.update({
    id: '/code',
    path: '/code',
    getParentRoute: () => AuthenticatedAutomationsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/automations.code.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAutomationsFlowIdRoute =
  AuthenticatedAutomationsFlowIdRouteImport.update({
    id: '/$flowId',
    path: '/$flowId',
    getParentRoute: () => AuthenticatedAutomationsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/automations.$flowId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAppsAppIdRoute = AuthenticatedAppsAppIdRouteImport.update({
  id: '/$appId',
  path: '/$appId',
  getParentRoute: () => AuthenticatedAppsRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/apps.$appId.lazy').then((d) => d.Route),
)
const AuthenticatedAnalyticsTopicDiscoveryRoute =
  AuthenticatedAnalyticsTopicDiscoveryRouteImport.update({
    id: '/topic-discovery',
    path: '/topic-discovery',
    getParentRoute: () => AuthenticatedAnalyticsRoute,
  } as any)
const PluginsOutlookTaskpaneIndexRoute =
  PluginsOutlookTaskpaneIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PluginsOutlookTaskpaneRoute,
  } as any)
const AuthenticatedFlowsListIndexRoute =
  AuthenticatedFlowsListIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedFlowsListRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/flows._list.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAutomationsCodeIndexRoute =
  AuthenticatedAutomationsCodeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAutomationsCodeRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/automations.code.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAnalyticsTopicDiscoveryIndexRoute =
  AuthenticatedAnalyticsTopicDiscoveryIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAnalyticsTopicDiscoveryRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/analytics.topic-discovery.index.lazy').then(
      (d) => d.Route,
    ),
  )
const PluginsOutlookTaskpaneShowFileRoute =
  PluginsOutlookTaskpaneShowFileRouteImport.update({
    id: '/show-file',
    path: '/show-file',
    getParentRoute: () => PluginsOutlookTaskpaneRoute,
  } as any)
const PluginsOutlookOutlookAuthLoginRoute =
  PluginsOutlookOutlookAuthLoginRouteImport.update({
    id: '/login',
    path: '/login',
    getParentRoute: () => PluginsOutlookOutlookAuthRoute,
  } as any)
const PluginsOutlookOutlookAuthAuthErrorRoute =
  PluginsOutlookOutlookAuthAuthErrorRouteImport.update({
    id: '/auth-error',
    path: '/auth-error',
    getParentRoute: () => PluginsOutlookOutlookAuthRoute,
  } as any)
const PluginsOutlookOutlookAuthOutlookSetupRoute =
  PluginsOutlookOutlookAuthOutlookSetupRouteImport.update({
    id: '/_outlookSetup',
    getParentRoute: () => PluginsOutlookOutlookAuthRoute,
  } as any)
const AuthenticatedModelsExtractionModelIdRoute =
  AuthenticatedModelsExtractionModelIdRouteImport.update({
    id: '/extraction/$modelId',
    path: '/extraction/$modelId',
    getParentRoute: () => AuthenticatedModelsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/models.extraction.$modelId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedModelsClassificationModelIdRoute =
  AuthenticatedModelsClassificationModelIdRouteImport.update({
    id: '/classification/$modelId',
    path: '/classification/$modelId',
    getParentRoute: () => AuthenticatedModelsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/models.classification.$modelId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedIntegrationsTypeSetupRoute =
  AuthenticatedIntegrationsTypeSetupRouteImport.update({
    id: '/$type/setup',
    path: '/$type/setup',
    getParentRoute: () => AuthenticatedIntegrationsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/integrations.$type.setup.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedFlowsListTemplatesRoute =
  AuthenticatedFlowsListTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => AuthenticatedFlowsListRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/flows._list.templates.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedFlowsListCodeRoute =
  AuthenticatedFlowsListCodeRouteImport.update({
    id: '/code',
    path: '/code',
    getParentRoute: () => AuthenticatedFlowsListRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/flows._list.code.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAutomationsCodeNewRoute =
  AuthenticatedAutomationsCodeNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedAutomationsCodeRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/automations.code.new.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAutomationsCodeIdRoute =
  AuthenticatedAutomationsCodeIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedAutomationsCodeRoute,
  } as any)
const AuthenticatedAnalyticsTopicDiscoveryTopicDiscoveryIdRoute =
  AuthenticatedAnalyticsTopicDiscoveryTopicDiscoveryIdRouteImport.update({
    id: '/$topicDiscoveryId',
    path: '/$topicDiscoveryId',
    getParentRoute: () => AuthenticatedAnalyticsTopicDiscoveryRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/analytics.topic-discovery.$topicDiscoveryId.lazy').then(
      (d) => d.Route,
    ),
  )
const PluginsOutlookOutlookAuthOutlookSetupVerifyEmailRoute =
  PluginsOutlookOutlookAuthOutlookSetupVerifyEmailRouteImport.update({
    id: '/verify-email',
    path: '/verify-email',
    getParentRoute: () => PluginsOutlookOutlookAuthOutlookSetupRoute,
  } as any)
const PluginsOutlookOutlookAuthOutlookSetupNoOrgRoute =
  PluginsOutlookOutlookAuthOutlookSetupNoOrgRouteImport.update({
    id: '/no-org',
    path: '/no-org',
    getParentRoute: () => PluginsOutlookOutlookAuthOutlookSetupRoute,
  } as any)
const PluginsOutlookOutlookAuthOutlookSetupNoMemberRoute =
  PluginsOutlookOutlookAuthOutlookSetupNoMemberRouteImport.update({
    id: '/no-member',
    path: '/no-member',
    getParentRoute: () => PluginsOutlookOutlookAuthOutlookSetupRoute,
  } as any)
const PluginsOutlookOutlookAuthOutlookSetupNoAccessRoute =
  PluginsOutlookOutlookAuthOutlookSetupNoAccessRouteImport.update({
    id: '/no-access',
    path: '/no-access',
    getParentRoute: () => PluginsOutlookOutlookAuthOutlookSetupRoute,
  } as any)
const PluginsOutlookOutlookAuthOutlookSetupLinkAccountRoute =
  PluginsOutlookOutlookAuthOutlookSetupLinkAccountRouteImport.update({
    id: '/link-account',
    path: '/link-account',
    getParentRoute: () => PluginsOutlookOutlookAuthOutlookSetupRoute,
  } as any)
const PluginsOutlookOutlookAuthOutlookSetupEnableMfaRoute =
  PluginsOutlookOutlookAuthOutlookSetupEnableMfaRouteImport.update({
    id: '/enable-mfa',
    path: '/enable-mfa',
    getParentRoute: () => PluginsOutlookOutlookAuthOutlookSetupRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/auth-error': typeof AuthAuthErrorRoute
  '/enable-mfa': typeof AuthEnableMfaRoute
  '/link-account': typeof AuthLinkAccountRoute
  '/login': typeof AuthLoginRoute
  '/no-access': typeof AuthNoAccessRoute
  '/no-member': typeof AuthNoMemberRoute
  '/no-org': typeof AuthNoOrgRoute
  '/signup': typeof AuthSignupRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/analytics': typeof AuthenticatedAnalyticsRouteWithChildren
  '/apps': typeof AuthenticatedAppsRouteWithChildren
  '/automations': typeof AuthenticatedAutomationsRouteWithChildren
  '/flows': typeof AuthenticatedFlowsListRouteWithChildren
  '/integrations': typeof AuthenticatedIntegrationsRouteWithChildren
  '/messages': typeof AuthenticatedMessagesRoute
  '/models': typeof AuthenticatedModelsRouteWithChildren
  '/processes': typeof AuthenticatedProcessesRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/plugins/outlook': typeof PluginsOutlookOutlookAuthOutlookSetupRouteWithChildren
  '/analytics/topic-discovery': typeof AuthenticatedAnalyticsTopicDiscoveryRouteWithChildren
  '/apps/$appId': typeof AuthenticatedAppsAppIdRoute
  '/automations/$flowId': typeof AuthenticatedAutomationsFlowIdRoute
  '/automations/code': typeof AuthenticatedAutomationsCodeRouteWithChildren
  '/automations/templates': typeof AuthenticatedAutomationsTemplatesRoute
  '/flows/$flowId': typeof AuthenticatedFlowsFlowIdRoute
  '/flows/new': typeof AuthenticatedFlowsNewRoute
  '/integrations/browse': typeof AuthenticatedIntegrationsBrowseRoute
  '/models/$modelId': typeof AuthenticatedModelsModelIdRoute
  '/processes/$processId': typeof AuthenticatedProcessesProcessIdRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/apikeys': typeof AuthenticatedSettingsApikeysRoute
  '/settings/audit-logs': typeof AuthenticatedSettingsAuditLogsRoute
  '/settings/organization': typeof AuthenticatedSettingsOrganizationRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/settings/sso': typeof AuthenticatedSettingsSsoRoute
  '/settings/users': typeof AuthenticatedSettingsUsersRoute
  '/test-hooks/useQueryParams': typeof AuthenticatedTestHooksUseQueryParamsRoute
  '/plugins/outlook/dialog': typeof PluginsOutlookDialogRoute
  '/plugins/outlook/taskpane': typeof PluginsOutlookTaskpaneRouteWithChildren
  '/analytics/': typeof AuthenticatedAnalyticsIndexRoute
  '/apps/': typeof AuthenticatedAppsIndexRoute
  '/automations/': typeof AuthenticatedAutomationsIndexRoute
  '/integrations/': typeof AuthenticatedIntegrationsIndexRoute
  '/models/': typeof AuthenticatedModelsIndexRoute
  '/processes/': typeof AuthenticatedProcessesIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/analytics/topic-discovery/$topicDiscoveryId': typeof AuthenticatedAnalyticsTopicDiscoveryTopicDiscoveryIdRoute
  '/automations/code/$id': typeof AuthenticatedAutomationsCodeIdRoute
  '/automations/code/new': typeof AuthenticatedAutomationsCodeNewRoute
  '/flows/code': typeof AuthenticatedFlowsListCodeRoute
  '/flows/templates': typeof AuthenticatedFlowsListTemplatesRoute
  '/integrations/$type/setup': typeof AuthenticatedIntegrationsTypeSetupRoute
  '/models/classification/$modelId': typeof AuthenticatedModelsClassificationModelIdRoute
  '/models/extraction/$modelId': typeof AuthenticatedModelsExtractionModelIdRoute
  '/plugins/outlook/auth-error': typeof PluginsOutlookOutlookAuthAuthErrorRoute
  '/plugins/outlook/login': typeof PluginsOutlookOutlookAuthLoginRoute
  '/plugins/outlook/taskpane/show-file': typeof PluginsOutlookTaskpaneShowFileRoute
  '/analytics/topic-discovery/': typeof AuthenticatedAnalyticsTopicDiscoveryIndexRoute
  '/automations/code/': typeof AuthenticatedAutomationsCodeIndexRoute
  '/flows/': typeof AuthenticatedFlowsListIndexRoute
  '/plugins/outlook/taskpane/': typeof PluginsOutlookTaskpaneIndexRoute
  '/plugins/outlook/enable-mfa': typeof PluginsOutlookOutlookAuthOutlookSetupEnableMfaRoute
  '/plugins/outlook/link-account': typeof PluginsOutlookOutlookAuthOutlookSetupLinkAccountRoute
  '/plugins/outlook/no-access': typeof PluginsOutlookOutlookAuthOutlookSetupNoAccessRoute
  '/plugins/outlook/no-member': typeof PluginsOutlookOutlookAuthOutlookSetupNoMemberRoute
  '/plugins/outlook/no-org': typeof PluginsOutlookOutlookAuthOutlookSetupNoOrgRoute
  '/plugins/outlook/verify-email': typeof PluginsOutlookOutlookAuthOutlookSetupVerifyEmailRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute
  '/auth-error': typeof AuthAuthErrorRoute
  '/enable-mfa': typeof AuthEnableMfaRoute
  '/link-account': typeof AuthLinkAccountRoute
  '/login': typeof AuthLoginRoute
  '/no-access': typeof AuthNoAccessRoute
  '/no-member': typeof AuthNoMemberRoute
  '/no-org': typeof AuthNoOrgRoute
  '/signup': typeof AuthSignupRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/flows': typeof AuthenticatedFlowsListIndexRoute
  '/messages': typeof AuthenticatedMessagesRoute
  '/plugins/outlook': typeof PluginsOutlookOutlookAuthOutlookSetupRouteWithChildren
  '/apps/$appId': typeof AuthenticatedAppsAppIdRoute
  '/automations/$flowId': typeof AuthenticatedAutomationsFlowIdRoute
  '/automations/templates': typeof AuthenticatedAutomationsTemplatesRoute
  '/flows/$flowId': typeof AuthenticatedFlowsFlowIdRoute
  '/flows/new': typeof AuthenticatedFlowsNewRoute
  '/integrations/browse': typeof AuthenticatedIntegrationsBrowseRoute
  '/models/$modelId': typeof AuthenticatedModelsModelIdRoute
  '/processes/$processId': typeof AuthenticatedProcessesProcessIdRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/apikeys': typeof AuthenticatedSettingsApikeysRoute
  '/settings/audit-logs': typeof AuthenticatedSettingsAuditLogsRoute
  '/settings/organization': typeof AuthenticatedSettingsOrganizationRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/settings/sso': typeof AuthenticatedSettingsSsoRoute
  '/settings/users': typeof AuthenticatedSettingsUsersRoute
  '/test-hooks/useQueryParams': typeof AuthenticatedTestHooksUseQueryParamsRoute
  '/plugins/outlook/dialog': typeof PluginsOutlookDialogRoute
  '/analytics': typeof AuthenticatedAnalyticsIndexRoute
  '/apps': typeof AuthenticatedAppsIndexRoute
  '/automations': typeof AuthenticatedAutomationsIndexRoute
  '/integrations': typeof AuthenticatedIntegrationsIndexRoute
  '/models': typeof AuthenticatedModelsIndexRoute
  '/processes': typeof AuthenticatedProcessesIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/analytics/topic-discovery/$topicDiscoveryId': typeof AuthenticatedAnalyticsTopicDiscoveryTopicDiscoveryIdRoute
  '/automations/code/$id': typeof AuthenticatedAutomationsCodeIdRoute
  '/automations/code/new': typeof AuthenticatedAutomationsCodeNewRoute
  '/flows/code': typeof AuthenticatedFlowsListCodeRoute
  '/flows/templates': typeof AuthenticatedFlowsListTemplatesRoute
  '/integrations/$type/setup': typeof AuthenticatedIntegrationsTypeSetupRoute
  '/models/classification/$modelId': typeof AuthenticatedModelsClassificationModelIdRoute
  '/models/extraction/$modelId': typeof AuthenticatedModelsExtractionModelIdRoute
  '/plugins/outlook/auth-error': typeof PluginsOutlookOutlookAuthAuthErrorRoute
  '/plugins/outlook/login': typeof PluginsOutlookOutlookAuthLoginRoute
  '/plugins/outlook/taskpane/show-file': typeof PluginsOutlookTaskpaneShowFileRoute
  '/analytics/topic-discovery': typeof AuthenticatedAnalyticsTopicDiscoveryIndexRoute
  '/automations/code': typeof AuthenticatedAutomationsCodeIndexRoute
  '/plugins/outlook/taskpane': typeof PluginsOutlookTaskpaneIndexRoute
  '/plugins/outlook/enable-mfa': typeof PluginsOutlookOutlookAuthOutlookSetupEnableMfaRoute
  '/plugins/outlook/link-account': typeof PluginsOutlookOutlookAuthOutlookSetupLinkAccountRoute
  '/plugins/outlook/no-access': typeof PluginsOutlookOutlookAuthOutlookSetupNoAccessRoute
  '/plugins/outlook/no-member': typeof PluginsOutlookOutlookAuthOutlookSetupNoMemberRoute
  '/plugins/outlook/no-org': typeof PluginsOutlookOutlookAuthOutlookSetupNoOrgRoute
  '/plugins/outlook/verify-email': typeof PluginsOutlookOutlookAuthOutlookSetupVerifyEmailRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_auth/auth-error': typeof AuthAuthErrorRoute
  '/_auth/enable-mfa': typeof AuthEnableMfaRoute
  '/_auth/link-account': typeof AuthLinkAccountRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/no-access': typeof AuthNoAccessRoute
  '/_auth/no-member': typeof AuthNoMemberRoute
  '/_auth/no-org': typeof AuthNoOrgRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/_auth/verify-email': typeof AuthVerifyEmailRoute
  '/_authenticated/analytics': typeof AuthenticatedAnalyticsRouteWithChildren
  '/_authenticated/apps': typeof AuthenticatedAppsRouteWithChildren
  '/_authenticated/automations': typeof AuthenticatedAutomationsRouteWithChildren
  '/_authenticated/flows': typeof AuthenticatedFlowsRouteWithChildren
  '/_authenticated/integrations': typeof AuthenticatedIntegrationsRouteWithChildren
  '/_authenticated/messages': typeof AuthenticatedMessagesRoute
  '/_authenticated/models': typeof AuthenticatedModelsRouteWithChildren
  '/_authenticated/processes': typeof AuthenticatedProcessesRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/plugins/outlook': typeof PluginsOutlookRouteWithChildren
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/analytics/topic-discovery': typeof AuthenticatedAnalyticsTopicDiscoveryRouteWithChildren
  '/_authenticated/apps/$appId': typeof AuthenticatedAppsAppIdRoute
  '/_authenticated/automations/$flowId': typeof AuthenticatedAutomationsFlowIdRoute
  '/_authenticated/automations/code': typeof AuthenticatedAutomationsCodeRouteWithChildren
  '/_authenticated/automations/templates': typeof AuthenticatedAutomationsTemplatesRoute
  '/_authenticated/flows/$flowId': typeof AuthenticatedFlowsFlowIdRoute
  '/_authenticated/flows/_list': typeof AuthenticatedFlowsListRouteWithChildren
  '/_authenticated/flows/new': typeof AuthenticatedFlowsNewRoute
  '/_authenticated/integrations/browse': typeof AuthenticatedIntegrationsBrowseRoute
  '/_authenticated/models/$modelId': typeof AuthenticatedModelsModelIdRoute
  '/_authenticated/processes/$processId': typeof AuthenticatedProcessesProcessIdRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/_authenticated/settings/apikeys': typeof AuthenticatedSettingsApikeysRoute
  '/_authenticated/settings/audit-logs': typeof AuthenticatedSettingsAuditLogsRoute
  '/_authenticated/settings/organization': typeof AuthenticatedSettingsOrganizationRoute
  '/_authenticated/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/_authenticated/settings/sso': typeof AuthenticatedSettingsSsoRoute
  '/_authenticated/settings/users': typeof AuthenticatedSettingsUsersRoute
  '/_authenticated/test-hooks/useQueryParams': typeof AuthenticatedTestHooksUseQueryParamsRoute
  '/plugins/outlook/_outlookAuth': typeof PluginsOutlookOutlookAuthRouteWithChildren
  '/plugins/outlook/dialog': typeof PluginsOutlookDialogRoute
  '/plugins/outlook/taskpane': typeof PluginsOutlookTaskpaneRouteWithChildren
  '/_authenticated/analytics/': typeof AuthenticatedAnalyticsIndexRoute
  '/_authenticated/apps/': typeof AuthenticatedAppsIndexRoute
  '/_authenticated/automations/': typeof AuthenticatedAutomationsIndexRoute
  '/_authenticated/integrations/': typeof AuthenticatedIntegrationsIndexRoute
  '/_authenticated/models/': typeof AuthenticatedModelsIndexRoute
  '/_authenticated/processes/': typeof AuthenticatedProcessesIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/analytics/topic-discovery/$topicDiscoveryId': typeof AuthenticatedAnalyticsTopicDiscoveryTopicDiscoveryIdRoute
  '/_authenticated/automations/code/$id': typeof AuthenticatedAutomationsCodeIdRoute
  '/_authenticated/automations/code/new': typeof AuthenticatedAutomationsCodeNewRoute
  '/_authenticated/flows/_list/code': typeof AuthenticatedFlowsListCodeRoute
  '/_authenticated/flows/_list/templates': typeof AuthenticatedFlowsListTemplatesRoute
  '/_authenticated/integrations/$type/setup': typeof AuthenticatedIntegrationsTypeSetupRoute
  '/_authenticated/models/classification/$modelId': typeof AuthenticatedModelsClassificationModelIdRoute
  '/_authenticated/models/extraction/$modelId': typeof AuthenticatedModelsExtractionModelIdRoute
  '/plugins/outlook/_outlookAuth/_outlookSetup': typeof PluginsOutlookOutlookAuthOutlookSetupRouteWithChildren
  '/plugins/outlook/_outlookAuth/auth-error': typeof PluginsOutlookOutlookAuthAuthErrorRoute
  '/plugins/outlook/_outlookAuth/login': typeof PluginsOutlookOutlookAuthLoginRoute
  '/plugins/outlook/taskpane/show-file': typeof PluginsOutlookTaskpaneShowFileRoute
  '/_authenticated/analytics/topic-discovery/': typeof AuthenticatedAnalyticsTopicDiscoveryIndexRoute
  '/_authenticated/automations/code/': typeof AuthenticatedAutomationsCodeIndexRoute
  '/_authenticated/flows/_list/': typeof AuthenticatedFlowsListIndexRoute
  '/plugins/outlook/taskpane/': typeof PluginsOutlookTaskpaneIndexRoute
  '/plugins/outlook/_outlookAuth/_outlookSetup/enable-mfa': typeof PluginsOutlookOutlookAuthOutlookSetupEnableMfaRoute
  '/plugins/outlook/_outlookAuth/_outlookSetup/link-account': typeof PluginsOutlookOutlookAuthOutlookSetupLinkAccountRoute
  '/plugins/outlook/_outlookAuth/_outlookSetup/no-access': typeof PluginsOutlookOutlookAuthOutlookSetupNoAccessRoute
  '/plugins/outlook/_outlookAuth/_outlookSetup/no-member': typeof PluginsOutlookOutlookAuthOutlookSetupNoMemberRoute
  '/plugins/outlook/_outlookAuth/_outlookSetup/no-org': typeof PluginsOutlookOutlookAuthOutlookSetupNoOrgRoute
  '/plugins/outlook/_outlookAuth/_outlookSetup/verify-email': typeof PluginsOutlookOutlookAuthOutlookSetupVerifyEmailRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth-error'
    | '/enable-mfa'
    | '/link-account'
    | '/login'
    | '/no-access'
    | '/no-member'
    | '/no-org'
    | '/signup'
    | '/verify-email'
    | '/analytics'
    | '/apps'
    | '/automations'
    | '/flows'
    | '/integrations'
    | '/messages'
    | '/models'
    | '/processes'
    | '/settings'
    | '/plugins/outlook'
    | '/analytics/topic-discovery'
    | '/apps/$appId'
    | '/automations/$flowId'
    | '/automations/code'
    | '/automations/templates'
    | '/flows/$flowId'
    | '/flows/new'
    | '/integrations/browse'
    | '/models/$modelId'
    | '/processes/$processId'
    | '/settings/account'
    | '/settings/apikeys'
    | '/settings/audit-logs'
    | '/settings/organization'
    | '/settings/security'
    | '/settings/sso'
    | '/settings/users'
    | '/test-hooks/useQueryParams'
    | '/plugins/outlook/dialog'
    | '/plugins/outlook/taskpane'
    | '/analytics/'
    | '/apps/'
    | '/automations/'
    | '/integrations/'
    | '/models/'
    | '/processes/'
    | '/settings/'
    | '/analytics/topic-discovery/$topicDiscoveryId'
    | '/automations/code/$id'
    | '/automations/code/new'
    | '/flows/code'
    | '/flows/templates'
    | '/integrations/$type/setup'
    | '/models/classification/$modelId'
    | '/models/extraction/$modelId'
    | '/plugins/outlook/auth-error'
    | '/plugins/outlook/login'
    | '/plugins/outlook/taskpane/show-file'
    | '/analytics/topic-discovery/'
    | '/automations/code/'
    | '/flows/'
    | '/plugins/outlook/taskpane/'
    | '/plugins/outlook/enable-mfa'
    | '/plugins/outlook/link-account'
    | '/plugins/outlook/no-access'
    | '/plugins/outlook/no-member'
    | '/plugins/outlook/no-org'
    | '/plugins/outlook/verify-email'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth-error'
    | '/enable-mfa'
    | '/link-account'
    | '/login'
    | '/no-access'
    | '/no-member'
    | '/no-org'
    | '/signup'
    | '/verify-email'
    | '/flows'
    | '/messages'
    | '/plugins/outlook'
    | '/apps/$appId'
    | '/automations/$flowId'
    | '/automations/templates'
    | '/flows/$flowId'
    | '/flows/new'
    | '/integrations/browse'
    | '/models/$modelId'
    | '/processes/$processId'
    | '/settings/account'
    | '/settings/apikeys'
    | '/settings/audit-logs'
    | '/settings/organization'
    | '/settings/security'
    | '/settings/sso'
    | '/settings/users'
    | '/test-hooks/useQueryParams'
    | '/plugins/outlook/dialog'
    | '/analytics'
    | '/apps'
    | '/automations'
    | '/integrations'
    | '/models'
    | '/processes'
    | '/settings'
    | '/analytics/topic-discovery/$topicDiscoveryId'
    | '/automations/code/$id'
    | '/automations/code/new'
    | '/flows/code'
    | '/flows/templates'
    | '/integrations/$type/setup'
    | '/models/classification/$modelId'
    | '/models/extraction/$modelId'
    | '/plugins/outlook/auth-error'
    | '/plugins/outlook/login'
    | '/plugins/outlook/taskpane/show-file'
    | '/analytics/topic-discovery'
    | '/automations/code'
    | '/plugins/outlook/taskpane'
    | '/plugins/outlook/enable-mfa'
    | '/plugins/outlook/link-account'
    | '/plugins/outlook/no-access'
    | '/plugins/outlook/no-member'
    | '/plugins/outlook/no-org'
    | '/plugins/outlook/verify-email'
  id:
    | '__root__'
    | '/_auth'
    | '/_authenticated'
    | '/_auth/auth-error'
    | '/_auth/enable-mfa'
    | '/_auth/link-account'
    | '/_auth/login'
    | '/_auth/no-access'
    | '/_auth/no-member'
    | '/_auth/no-org'
    | '/_auth/signup'
    | '/_auth/verify-email'
    | '/_authenticated/analytics'
    | '/_authenticated/apps'
    | '/_authenticated/automations'
    | '/_authenticated/flows'
    | '/_authenticated/integrations'
    | '/_authenticated/messages'
    | '/_authenticated/models'
    | '/_authenticated/processes'
    | '/_authenticated/settings'
    | '/plugins/outlook'
    | '/_authenticated/'
    | '/_authenticated/analytics/topic-discovery'
    | '/_authenticated/apps/$appId'
    | '/_authenticated/automations/$flowId'
    | '/_authenticated/automations/code'
    | '/_authenticated/automations/templates'
    | '/_authenticated/flows/$flowId'
    | '/_authenticated/flows/_list'
    | '/_authenticated/flows/new'
    | '/_authenticated/integrations/browse'
    | '/_authenticated/models/$modelId'
    | '/_authenticated/processes/$processId'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/apikeys'
    | '/_authenticated/settings/audit-logs'
    | '/_authenticated/settings/organization'
    | '/_authenticated/settings/security'
    | '/_authenticated/settings/sso'
    | '/_authenticated/settings/users'
    | '/_authenticated/test-hooks/useQueryParams'
    | '/plugins/outlook/_outlookAuth'
    | '/plugins/outlook/dialog'
    | '/plugins/outlook/taskpane'
    | '/_authenticated/analytics/'
    | '/_authenticated/apps/'
    | '/_authenticated/automations/'
    | '/_authenticated/integrations/'
    | '/_authenticated/models/'
    | '/_authenticated/processes/'
    | '/_authenticated/settings/'
    | '/_authenticated/analytics/topic-discovery/$topicDiscoveryId'
    | '/_authenticated/automations/code/$id'
    | '/_authenticated/automations/code/new'
    | '/_authenticated/flows/_list/code'
    | '/_authenticated/flows/_list/templates'
    | '/_authenticated/integrations/$type/setup'
    | '/_authenticated/models/classification/$modelId'
    | '/_authenticated/models/extraction/$modelId'
    | '/plugins/outlook/_outlookAuth/_outlookSetup'
    | '/plugins/outlook/_outlookAuth/auth-error'
    | '/plugins/outlook/_outlookAuth/login'
    | '/plugins/outlook/taskpane/show-file'
    | '/_authenticated/analytics/topic-discovery/'
    | '/_authenticated/automations/code/'
    | '/_authenticated/flows/_list/'
    | '/plugins/outlook/taskpane/'
    | '/plugins/outlook/_outlookAuth/_outlookSetup/enable-mfa'
    | '/plugins/outlook/_outlookAuth/_outlookSetup/link-account'
    | '/plugins/outlook/_outlookAuth/_outlookSetup/no-access'
    | '/plugins/outlook/_outlookAuth/_outlookSetup/no-member'
    | '/plugins/outlook/_outlookAuth/_outlookSetup/no-org'
    | '/plugins/outlook/_outlookAuth/_outlookSetup/verify-email'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PluginsOutlookRoute: typeof PluginsOutlookRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/plugins/outlook': {
      id: '/plugins/outlook'
      path: '/plugins/outlook'
      fullPath: '/plugins/outlook'
      preLoaderRoute: typeof PluginsOutlookRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/processes': {
      id: '/_authenticated/processes'
      path: '/processes'
      fullPath: '/processes'
      preLoaderRoute: typeof AuthenticatedProcessesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/models': {
      id: '/_authenticated/models'
      path: '/models'
      fullPath: '/models'
      preLoaderRoute: typeof AuthenticatedModelsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/messages': {
      id: '/_authenticated/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AuthenticatedMessagesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/integrations': {
      id: '/_authenticated/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AuthenticatedIntegrationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/flows': {
      id: '/_authenticated/flows'
      path: '/flows'
      fullPath: '/flows'
      preLoaderRoute: typeof AuthenticatedFlowsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/automations': {
      id: '/_authenticated/automations'
      path: '/automations'
      fullPath: '/automations'
      preLoaderRoute: typeof AuthenticatedAutomationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/apps': {
      id: '/_authenticated/apps'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AuthenticatedAppsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/analytics': {
      id: '/_authenticated/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthenticatedAnalyticsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_auth/verify-email': {
      id: '/_auth/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/no-org': {
      id: '/_auth/no-org'
      path: '/no-org'
      fullPath: '/no-org'
      preLoaderRoute: typeof AuthNoOrgRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/no-member': {
      id: '/_auth/no-member'
      path: '/no-member'
      fullPath: '/no-member'
      preLoaderRoute: typeof AuthNoMemberRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/no-access': {
      id: '/_auth/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof AuthNoAccessRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/link-account': {
      id: '/_auth/link-account'
      path: '/link-account'
      fullPath: '/link-account'
      preLoaderRoute: typeof AuthLinkAccountRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/enable-mfa': {
      id: '/_auth/enable-mfa'
      path: '/enable-mfa'
      fullPath: '/enable-mfa'
      preLoaderRoute: typeof AuthEnableMfaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/auth-error': {
      id: '/_auth/auth-error'
      path: '/auth-error'
      fullPath: '/auth-error'
      preLoaderRoute: typeof AuthAuthErrorRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/processes/': {
      id: '/_authenticated/processes/'
      path: '/'
      fullPath: '/processes/'
      preLoaderRoute: typeof AuthenticatedProcessesIndexRouteImport
      parentRoute: typeof AuthenticatedProcessesRoute
    }
    '/_authenticated/models/': {
      id: '/_authenticated/models/'
      path: '/'
      fullPath: '/models/'
      preLoaderRoute: typeof AuthenticatedModelsIndexRouteImport
      parentRoute: typeof AuthenticatedModelsRoute
    }
    '/_authenticated/integrations/': {
      id: '/_authenticated/integrations/'
      path: '/'
      fullPath: '/integrations/'
      preLoaderRoute: typeof AuthenticatedIntegrationsIndexRouteImport
      parentRoute: typeof AuthenticatedIntegrationsRoute
    }
    '/_authenticated/automations/': {
      id: '/_authenticated/automations/'
      path: '/'
      fullPath: '/automations/'
      preLoaderRoute: typeof AuthenticatedAutomationsIndexRouteImport
      parentRoute: typeof AuthenticatedAutomationsRoute
    }
    '/_authenticated/apps/': {
      id: '/_authenticated/apps/'
      path: '/'
      fullPath: '/apps/'
      preLoaderRoute: typeof AuthenticatedAppsIndexRouteImport
      parentRoute: typeof AuthenticatedAppsRoute
    }
    '/_authenticated/analytics/': {
      id: '/_authenticated/analytics/'
      path: '/'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AuthenticatedAnalyticsIndexRouteImport
      parentRoute: typeof AuthenticatedAnalyticsRoute
    }
    '/plugins/outlook/taskpane': {
      id: '/plugins/outlook/taskpane'
      path: '/taskpane'
      fullPath: '/plugins/outlook/taskpane'
      preLoaderRoute: typeof PluginsOutlookTaskpaneRouteImport
      parentRoute: typeof PluginsOutlookRoute
    }
    '/plugins/outlook/dialog': {
      id: '/plugins/outlook/dialog'
      path: '/dialog'
      fullPath: '/plugins/outlook/dialog'
      preLoaderRoute: typeof PluginsOutlookDialogRouteImport
      parentRoute: typeof PluginsOutlookRoute
    }
    '/plugins/outlook/_outlookAuth': {
      id: '/plugins/outlook/_outlookAuth'
      path: ''
      fullPath: '/plugins/outlook'
      preLoaderRoute: typeof PluginsOutlookOutlookAuthRouteImport
      parentRoute: typeof PluginsOutlookRoute
    }
    '/_authenticated/test-hooks/useQueryParams': {
      id: '/_authenticated/test-hooks/useQueryParams'
      path: '/test-hooks/useQueryParams'
      fullPath: '/test-hooks/useQueryParams'
      preLoaderRoute: typeof AuthenticatedTestHooksUseQueryParamsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/users': {
      id: '/_authenticated/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AuthenticatedSettingsUsersRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/sso': {
      id: '/_authenticated/settings/sso'
      path: '/sso'
      fullPath: '/settings/sso'
      preLoaderRoute: typeof AuthenticatedSettingsSsoRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/security': {
      id: '/_authenticated/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AuthenticatedSettingsSecurityRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/organization': {
      id: '/_authenticated/settings/organization'
      path: '/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof AuthenticatedSettingsOrganizationRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/audit-logs': {
      id: '/_authenticated/settings/audit-logs'
      path: '/audit-logs'
      fullPath: '/settings/audit-logs'
      preLoaderRoute: typeof AuthenticatedSettingsAuditLogsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/apikeys': {
      id: '/_authenticated/settings/apikeys'
      path: '/apikeys'
      fullPath: '/settings/apikeys'
      preLoaderRoute: typeof AuthenticatedSettingsApikeysRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/processes/$processId': {
      id: '/_authenticated/processes/$processId'
      path: '/$processId'
      fullPath: '/processes/$processId'
      preLoaderRoute: typeof AuthenticatedProcessesProcessIdRouteImport
      parentRoute: typeof AuthenticatedProcessesRoute
    }
    '/_authenticated/models/$modelId': {
      id: '/_authenticated/models/$modelId'
      path: '/$modelId'
      fullPath: '/models/$modelId'
      preLoaderRoute: typeof AuthenticatedModelsModelIdRouteImport
      parentRoute: typeof AuthenticatedModelsRoute
    }
    '/_authenticated/integrations/browse': {
      id: '/_authenticated/integrations/browse'
      path: '/browse'
      fullPath: '/integrations/browse'
      preLoaderRoute: typeof AuthenticatedIntegrationsBrowseRouteImport
      parentRoute: typeof AuthenticatedIntegrationsRoute
    }
    '/_authenticated/flows/new': {
      id: '/_authenticated/flows/new'
      path: '/new'
      fullPath: '/flows/new'
      preLoaderRoute: typeof AuthenticatedFlowsNewRouteImport
      parentRoute: typeof AuthenticatedFlowsRoute
    }
    '/_authenticated/flows/_list': {
      id: '/_authenticated/flows/_list'
      path: ''
      fullPath: '/flows'
      preLoaderRoute: typeof AuthenticatedFlowsListRouteImport
      parentRoute: typeof AuthenticatedFlowsRoute
    }
    '/_authenticated/flows/$flowId': {
      id: '/_authenticated/flows/$flowId'
      path: '/$flowId'
      fullPath: '/flows/$flowId'
      preLoaderRoute: typeof AuthenticatedFlowsFlowIdRouteImport
      parentRoute: typeof AuthenticatedFlowsRoute
    }
    '/_authenticated/automations/templates': {
      id: '/_authenticated/automations/templates'
      path: '/templates'
      fullPath: '/automations/templates'
      preLoaderRoute: typeof AuthenticatedAutomationsTemplatesRouteImport
      parentRoute: typeof AuthenticatedAutomationsRoute
    }
    '/_authenticated/automations/code': {
      id: '/_authenticated/automations/code'
      path: '/code'
      fullPath: '/automations/code'
      preLoaderRoute: typeof AuthenticatedAutomationsCodeRouteImport
      parentRoute: typeof AuthenticatedAutomationsRoute
    }
    '/_authenticated/automations/$flowId': {
      id: '/_authenticated/automations/$flowId'
      path: '/$flowId'
      fullPath: '/automations/$flowId'
      preLoaderRoute: typeof AuthenticatedAutomationsFlowIdRouteImport
      parentRoute: typeof AuthenticatedAutomationsRoute
    }
    '/_authenticated/apps/$appId': {
      id: '/_authenticated/apps/$appId'
      path: '/$appId'
      fullPath: '/apps/$appId'
      preLoaderRoute: typeof AuthenticatedAppsAppIdRouteImport
      parentRoute: typeof AuthenticatedAppsRoute
    }
    '/_authenticated/analytics/topic-discovery': {
      id: '/_authenticated/analytics/topic-discovery'
      path: '/topic-discovery'
      fullPath: '/analytics/topic-discovery'
      preLoaderRoute: typeof AuthenticatedAnalyticsTopicDiscoveryRouteImport
      parentRoute: typeof AuthenticatedAnalyticsRoute
    }
    '/plugins/outlook/taskpane/': {
      id: '/plugins/outlook/taskpane/'
      path: '/'
      fullPath: '/plugins/outlook/taskpane/'
      preLoaderRoute: typeof PluginsOutlookTaskpaneIndexRouteImport
      parentRoute: typeof PluginsOutlookTaskpaneRoute
    }
    '/_authenticated/flows/_list/': {
      id: '/_authenticated/flows/_list/'
      path: '/'
      fullPath: '/flows/'
      preLoaderRoute: typeof AuthenticatedFlowsListIndexRouteImport
      parentRoute: typeof AuthenticatedFlowsListRoute
    }
    '/_authenticated/automations/code/': {
      id: '/_authenticated/automations/code/'
      path: '/'
      fullPath: '/automations/code/'
      preLoaderRoute: typeof AuthenticatedAutomationsCodeIndexRouteImport
      parentRoute: typeof AuthenticatedAutomationsCodeRoute
    }
    '/_authenticated/analytics/topic-discovery/': {
      id: '/_authenticated/analytics/topic-discovery/'
      path: '/'
      fullPath: '/analytics/topic-discovery/'
      preLoaderRoute: typeof AuthenticatedAnalyticsTopicDiscoveryIndexRouteImport
      parentRoute: typeof AuthenticatedAnalyticsTopicDiscoveryRoute
    }
    '/plugins/outlook/taskpane/show-file': {
      id: '/plugins/outlook/taskpane/show-file'
      path: '/show-file'
      fullPath: '/plugins/outlook/taskpane/show-file'
      preLoaderRoute: typeof PluginsOutlookTaskpaneShowFileRouteImport
      parentRoute: typeof PluginsOutlookTaskpaneRoute
    }
    '/plugins/outlook/_outlookAuth/login': {
      id: '/plugins/outlook/_outlookAuth/login'
      path: '/login'
      fullPath: '/plugins/outlook/login'
      preLoaderRoute: typeof PluginsOutlookOutlookAuthLoginRouteImport
      parentRoute: typeof PluginsOutlookOutlookAuthRoute
    }
    '/plugins/outlook/_outlookAuth/auth-error': {
      id: '/plugins/outlook/_outlookAuth/auth-error'
      path: '/auth-error'
      fullPath: '/plugins/outlook/auth-error'
      preLoaderRoute: typeof PluginsOutlookOutlookAuthAuthErrorRouteImport
      parentRoute: typeof PluginsOutlookOutlookAuthRoute
    }
    '/plugins/outlook/_outlookAuth/_outlookSetup': {
      id: '/plugins/outlook/_outlookAuth/_outlookSetup'
      path: ''
      fullPath: '/plugins/outlook'
      preLoaderRoute: typeof PluginsOutlookOutlookAuthOutlookSetupRouteImport
      parentRoute: typeof PluginsOutlookOutlookAuthRoute
    }
    '/_authenticated/models/extraction/$modelId': {
      id: '/_authenticated/models/extraction/$modelId'
      path: '/extraction/$modelId'
      fullPath: '/models/extraction/$modelId'
      preLoaderRoute: typeof AuthenticatedModelsExtractionModelIdRouteImport
      parentRoute: typeof AuthenticatedModelsRoute
    }
    '/_authenticated/models/classification/$modelId': {
      id: '/_authenticated/models/classification/$modelId'
      path: '/classification/$modelId'
      fullPath: '/models/classification/$modelId'
      preLoaderRoute: typeof AuthenticatedModelsClassificationModelIdRouteImport
      parentRoute: typeof AuthenticatedModelsRoute
    }
    '/_authenticated/integrations/$type/setup': {
      id: '/_authenticated/integrations/$type/setup'
      path: '/$type/setup'
      fullPath: '/integrations/$type/setup'
      preLoaderRoute: typeof AuthenticatedIntegrationsTypeSetupRouteImport
      parentRoute: typeof AuthenticatedIntegrationsRoute
    }
    '/_authenticated/flows/_list/templates': {
      id: '/_authenticated/flows/_list/templates'
      path: '/templates'
      fullPath: '/flows/templates'
      preLoaderRoute: typeof AuthenticatedFlowsListTemplatesRouteImport
      parentRoute: typeof AuthenticatedFlowsListRoute
    }
    '/_authenticated/flows/_list/code': {
      id: '/_authenticated/flows/_list/code'
      path: '/code'
      fullPath: '/flows/code'
      preLoaderRoute: typeof AuthenticatedFlowsListCodeRouteImport
      parentRoute: typeof AuthenticatedFlowsListRoute
    }
    '/_authenticated/automations/code/new': {
      id: '/_authenticated/automations/code/new'
      path: '/new'
      fullPath: '/automations/code/new'
      preLoaderRoute: typeof AuthenticatedAutomationsCodeNewRouteImport
      parentRoute: typeof AuthenticatedAutomationsCodeRoute
    }
    '/_authenticated/automations/code/$id': {
      id: '/_authenticated/automations/code/$id'
      path: '/$id'
      fullPath: '/automations/code/$id'
      preLoaderRoute: typeof AuthenticatedAutomationsCodeIdRouteImport
      parentRoute: typeof AuthenticatedAutomationsCodeRoute
    }
    '/_authenticated/analytics/topic-discovery/$topicDiscoveryId': {
      id: '/_authenticated/analytics/topic-discovery/$topicDiscoveryId'
      path: '/$topicDiscoveryId'
      fullPath: '/analytics/topic-discovery/$topicDiscoveryId'
      preLoaderRoute: typeof AuthenticatedAnalyticsTopicDiscoveryTopicDiscoveryIdRouteImport
      parentRoute: typeof AuthenticatedAnalyticsTopicDiscoveryRoute
    }
    '/plugins/outlook/_outlookAuth/_outlookSetup/verify-email': {
      id: '/plugins/outlook/_outlookAuth/_outlookSetup/verify-email'
      path: '/verify-email'
      fullPath: '/plugins/outlook/verify-email'
      preLoaderRoute: typeof PluginsOutlookOutlookAuthOutlookSetupVerifyEmailRouteImport
      parentRoute: typeof PluginsOutlookOutlookAuthOutlookSetupRoute
    }
    '/plugins/outlook/_outlookAuth/_outlookSetup/no-org': {
      id: '/plugins/outlook/_outlookAuth/_outlookSetup/no-org'
      path: '/no-org'
      fullPath: '/plugins/outlook/no-org'
      preLoaderRoute: typeof PluginsOutlookOutlookAuthOutlookSetupNoOrgRouteImport
      parentRoute: typeof PluginsOutlookOutlookAuthOutlookSetupRoute
    }
    '/plugins/outlook/_outlookAuth/_outlookSetup/no-member': {
      id: '/plugins/outlook/_outlookAuth/_outlookSetup/no-member'
      path: '/no-member'
      fullPath: '/plugins/outlook/no-member'
      preLoaderRoute: typeof PluginsOutlookOutlookAuthOutlookSetupNoMemberRouteImport
      parentRoute: typeof PluginsOutlookOutlookAuthOutlookSetupRoute
    }
    '/plugins/outlook/_outlookAuth/_outlookSetup/no-access': {
      id: '/plugins/outlook/_outlookAuth/_outlookSetup/no-access'
      path: '/no-access'
      fullPath: '/plugins/outlook/no-access'
      preLoaderRoute: typeof PluginsOutlookOutlookAuthOutlookSetupNoAccessRouteImport
      parentRoute: typeof PluginsOutlookOutlookAuthOutlookSetupRoute
    }
    '/plugins/outlook/_outlookAuth/_outlookSetup/link-account': {
      id: '/plugins/outlook/_outlookAuth/_outlookSetup/link-account'
      path: '/link-account'
      fullPath: '/plugins/outlook/link-account'
      preLoaderRoute: typeof PluginsOutlookOutlookAuthOutlookSetupLinkAccountRouteImport
      parentRoute: typeof PluginsOutlookOutlookAuthOutlookSetupRoute
    }
    '/plugins/outlook/_outlookAuth/_outlookSetup/enable-mfa': {
      id: '/plugins/outlook/_outlookAuth/_outlookSetup/enable-mfa'
      path: '/enable-mfa'
      fullPath: '/plugins/outlook/enable-mfa'
      preLoaderRoute: typeof PluginsOutlookOutlookAuthOutlookSetupEnableMfaRouteImport
      parentRoute: typeof PluginsOutlookOutlookAuthOutlookSetupRoute
    }
  }
}

interface AuthRouteChildren {
  AuthAuthErrorRoute: typeof AuthAuthErrorRoute
  AuthEnableMfaRoute: typeof AuthEnableMfaRoute
  AuthLinkAccountRoute: typeof AuthLinkAccountRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthNoAccessRoute: typeof AuthNoAccessRoute
  AuthNoMemberRoute: typeof AuthNoMemberRoute
  AuthNoOrgRoute: typeof AuthNoOrgRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAuthErrorRoute: AuthAuthErrorRoute,
  AuthEnableMfaRoute: AuthEnableMfaRoute,
  AuthLinkAccountRoute: AuthLinkAccountRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthNoAccessRoute: AuthNoAccessRoute,
  AuthNoMemberRoute: AuthNoMemberRoute,
  AuthNoOrgRoute: AuthNoOrgRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthenticatedAnalyticsTopicDiscoveryRouteChildren {
  AuthenticatedAnalyticsTopicDiscoveryTopicDiscoveryIdRoute: typeof AuthenticatedAnalyticsTopicDiscoveryTopicDiscoveryIdRoute
  AuthenticatedAnalyticsTopicDiscoveryIndexRoute: typeof AuthenticatedAnalyticsTopicDiscoveryIndexRoute
}

const AuthenticatedAnalyticsTopicDiscoveryRouteChildren: AuthenticatedAnalyticsTopicDiscoveryRouteChildren =
  {
    AuthenticatedAnalyticsTopicDiscoveryTopicDiscoveryIdRoute:
      AuthenticatedAnalyticsTopicDiscoveryTopicDiscoveryIdRoute,
    AuthenticatedAnalyticsTopicDiscoveryIndexRoute:
      AuthenticatedAnalyticsTopicDiscoveryIndexRoute,
  }

const AuthenticatedAnalyticsTopicDiscoveryRouteWithChildren =
  AuthenticatedAnalyticsTopicDiscoveryRoute._addFileChildren(
    AuthenticatedAnalyticsTopicDiscoveryRouteChildren,
  )

interface AuthenticatedAnalyticsRouteChildren {
  AuthenticatedAnalyticsTopicDiscoveryRoute: typeof AuthenticatedAnalyticsTopicDiscoveryRouteWithChildren
  AuthenticatedAnalyticsIndexRoute: typeof AuthenticatedAnalyticsIndexRoute
}

const AuthenticatedAnalyticsRouteChildren: AuthenticatedAnalyticsRouteChildren =
  {
    AuthenticatedAnalyticsTopicDiscoveryRoute:
      AuthenticatedAnalyticsTopicDiscoveryRouteWithChildren,
    AuthenticatedAnalyticsIndexRoute: AuthenticatedAnalyticsIndexRoute,
  }

const AuthenticatedAnalyticsRouteWithChildren =
  AuthenticatedAnalyticsRoute._addFileChildren(
    AuthenticatedAnalyticsRouteChildren,
  )

interface AuthenticatedAppsRouteChildren {
  AuthenticatedAppsAppIdRoute: typeof AuthenticatedAppsAppIdRoute
  AuthenticatedAppsIndexRoute: typeof AuthenticatedAppsIndexRoute
}

const AuthenticatedAppsRouteChildren: AuthenticatedAppsRouteChildren = {
  AuthenticatedAppsAppIdRoute: AuthenticatedAppsAppIdRoute,
  AuthenticatedAppsIndexRoute: AuthenticatedAppsIndexRoute,
}

const AuthenticatedAppsRouteWithChildren =
  AuthenticatedAppsRoute._addFileChildren(AuthenticatedAppsRouteChildren)

interface AuthenticatedAutomationsCodeRouteChildren {
  AuthenticatedAutomationsCodeIdRoute: typeof AuthenticatedAutomationsCodeIdRoute
  AuthenticatedAutomationsCodeNewRoute: typeof AuthenticatedAutomationsCodeNewRoute
  AuthenticatedAutomationsCodeIndexRoute: typeof AuthenticatedAutomationsCodeIndexRoute
}

const AuthenticatedAutomationsCodeRouteChildren: AuthenticatedAutomationsCodeRouteChildren =
  {
    AuthenticatedAutomationsCodeIdRoute: AuthenticatedAutomationsCodeIdRoute,
    AuthenticatedAutomationsCodeNewRoute: AuthenticatedAutomationsCodeNewRoute,
    AuthenticatedAutomationsCodeIndexRoute:
      AuthenticatedAutomationsCodeIndexRoute,
  }

const AuthenticatedAutomationsCodeRouteWithChildren =
  AuthenticatedAutomationsCodeRoute._addFileChildren(
    AuthenticatedAutomationsCodeRouteChildren,
  )

interface AuthenticatedAutomationsRouteChildren {
  AuthenticatedAutomationsFlowIdRoute: typeof AuthenticatedAutomationsFlowIdRoute
  AuthenticatedAutomationsCodeRoute: typeof AuthenticatedAutomationsCodeRouteWithChildren
  AuthenticatedAutomationsTemplatesRoute: typeof AuthenticatedAutomationsTemplatesRoute
  AuthenticatedAutomationsIndexRoute: typeof AuthenticatedAutomationsIndexRoute
}

const AuthenticatedAutomationsRouteChildren: AuthenticatedAutomationsRouteChildren =
  {
    AuthenticatedAutomationsFlowIdRoute: AuthenticatedAutomationsFlowIdRoute,
    AuthenticatedAutomationsCodeRoute:
      AuthenticatedAutomationsCodeRouteWithChildren,
    AuthenticatedAutomationsTemplatesRoute:
      AuthenticatedAutomationsTemplatesRoute,
    AuthenticatedAutomationsIndexRoute: AuthenticatedAutomationsIndexRoute,
  }

const AuthenticatedAutomationsRouteWithChildren =
  AuthenticatedAutomationsRoute._addFileChildren(
    AuthenticatedAutomationsRouteChildren,
  )

interface AuthenticatedFlowsListRouteChildren {
  AuthenticatedFlowsListCodeRoute: typeof AuthenticatedFlowsListCodeRoute
  AuthenticatedFlowsListTemplatesRoute: typeof AuthenticatedFlowsListTemplatesRoute
  AuthenticatedFlowsListIndexRoute: typeof AuthenticatedFlowsListIndexRoute
}

const AuthenticatedFlowsListRouteChildren: AuthenticatedFlowsListRouteChildren =
  {
    AuthenticatedFlowsListCodeRoute: AuthenticatedFlowsListCodeRoute,
    AuthenticatedFlowsListTemplatesRoute: AuthenticatedFlowsListTemplatesRoute,
    AuthenticatedFlowsListIndexRoute: AuthenticatedFlowsListIndexRoute,
  }

const AuthenticatedFlowsListRouteWithChildren =
  AuthenticatedFlowsListRoute._addFileChildren(
    AuthenticatedFlowsListRouteChildren,
  )

interface AuthenticatedFlowsRouteChildren {
  AuthenticatedFlowsFlowIdRoute: typeof AuthenticatedFlowsFlowIdRoute
  AuthenticatedFlowsListRoute: typeof AuthenticatedFlowsListRouteWithChildren
  AuthenticatedFlowsNewRoute: typeof AuthenticatedFlowsNewRoute
}

const AuthenticatedFlowsRouteChildren: AuthenticatedFlowsRouteChildren = {
  AuthenticatedFlowsFlowIdRoute: AuthenticatedFlowsFlowIdRoute,
  AuthenticatedFlowsListRoute: AuthenticatedFlowsListRouteWithChildren,
  AuthenticatedFlowsNewRoute: AuthenticatedFlowsNewRoute,
}

const AuthenticatedFlowsRouteWithChildren =
  AuthenticatedFlowsRoute._addFileChildren(AuthenticatedFlowsRouteChildren)

interface AuthenticatedIntegrationsRouteChildren {
  AuthenticatedIntegrationsBrowseRoute: typeof AuthenticatedIntegrationsBrowseRoute
  AuthenticatedIntegrationsIndexRoute: typeof AuthenticatedIntegrationsIndexRoute
  AuthenticatedIntegrationsTypeSetupRoute: typeof AuthenticatedIntegrationsTypeSetupRoute
}

const AuthenticatedIntegrationsRouteChildren: AuthenticatedIntegrationsRouteChildren =
  {
    AuthenticatedIntegrationsBrowseRoute: AuthenticatedIntegrationsBrowseRoute,
    AuthenticatedIntegrationsIndexRoute: AuthenticatedIntegrationsIndexRoute,
    AuthenticatedIntegrationsTypeSetupRoute:
      AuthenticatedIntegrationsTypeSetupRoute,
  }

const AuthenticatedIntegrationsRouteWithChildren =
  AuthenticatedIntegrationsRoute._addFileChildren(
    AuthenticatedIntegrationsRouteChildren,
  )

interface AuthenticatedModelsRouteChildren {
  AuthenticatedModelsModelIdRoute: typeof AuthenticatedModelsModelIdRoute
  AuthenticatedModelsIndexRoute: typeof AuthenticatedModelsIndexRoute
  AuthenticatedModelsClassificationModelIdRoute: typeof AuthenticatedModelsClassificationModelIdRoute
  AuthenticatedModelsExtractionModelIdRoute: typeof AuthenticatedModelsExtractionModelIdRoute
}

const AuthenticatedModelsRouteChildren: AuthenticatedModelsRouteChildren = {
  AuthenticatedModelsModelIdRoute: AuthenticatedModelsModelIdRoute,
  AuthenticatedModelsIndexRoute: AuthenticatedModelsIndexRoute,
  AuthenticatedModelsClassificationModelIdRoute:
    AuthenticatedModelsClassificationModelIdRoute,
  AuthenticatedModelsExtractionModelIdRoute:
    AuthenticatedModelsExtractionModelIdRoute,
}

const AuthenticatedModelsRouteWithChildren =
  AuthenticatedModelsRoute._addFileChildren(AuthenticatedModelsRouteChildren)

interface AuthenticatedProcessesRouteChildren {
  AuthenticatedProcessesProcessIdRoute: typeof AuthenticatedProcessesProcessIdRoute
  AuthenticatedProcessesIndexRoute: typeof AuthenticatedProcessesIndexRoute
}

const AuthenticatedProcessesRouteChildren: AuthenticatedProcessesRouteChildren =
  {
    AuthenticatedProcessesProcessIdRoute: AuthenticatedProcessesProcessIdRoute,
    AuthenticatedProcessesIndexRoute: AuthenticatedProcessesIndexRoute,
  }

const AuthenticatedProcessesRouteWithChildren =
  AuthenticatedProcessesRoute._addFileChildren(
    AuthenticatedProcessesRouteChildren,
  )

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute
  AuthenticatedSettingsApikeysRoute: typeof AuthenticatedSettingsApikeysRoute
  AuthenticatedSettingsAuditLogsRoute: typeof AuthenticatedSettingsAuditLogsRoute
  AuthenticatedSettingsOrganizationRoute: typeof AuthenticatedSettingsOrganizationRoute
  AuthenticatedSettingsSecurityRoute: typeof AuthenticatedSettingsSecurityRoute
  AuthenticatedSettingsSsoRoute: typeof AuthenticatedSettingsSsoRoute
  AuthenticatedSettingsUsersRoute: typeof AuthenticatedSettingsUsersRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
  AuthenticatedSettingsApikeysRoute: AuthenticatedSettingsApikeysRoute,
  AuthenticatedSettingsAuditLogsRoute: AuthenticatedSettingsAuditLogsRoute,
  AuthenticatedSettingsOrganizationRoute:
    AuthenticatedSettingsOrganizationRoute,
  AuthenticatedSettingsSecurityRoute: AuthenticatedSettingsSecurityRoute,
  AuthenticatedSettingsSsoRoute: AuthenticatedSettingsSsoRoute,
  AuthenticatedSettingsUsersRoute: AuthenticatedSettingsUsersRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAnalyticsRoute: typeof AuthenticatedAnalyticsRouteWithChildren
  AuthenticatedAppsRoute: typeof AuthenticatedAppsRouteWithChildren
  AuthenticatedAutomationsRoute: typeof AuthenticatedAutomationsRouteWithChildren
  AuthenticatedFlowsRoute: typeof AuthenticatedFlowsRouteWithChildren
  AuthenticatedIntegrationsRoute: typeof AuthenticatedIntegrationsRouteWithChildren
  AuthenticatedMessagesRoute: typeof AuthenticatedMessagesRoute
  AuthenticatedModelsRoute: typeof AuthenticatedModelsRouteWithChildren
  AuthenticatedProcessesRoute: typeof AuthenticatedProcessesRouteWithChildren
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedTestHooksUseQueryParamsRoute: typeof AuthenticatedTestHooksUseQueryParamsRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAnalyticsRoute: AuthenticatedAnalyticsRouteWithChildren,
  AuthenticatedAppsRoute: AuthenticatedAppsRouteWithChildren,
  AuthenticatedAutomationsRoute: AuthenticatedAutomationsRouteWithChildren,
  AuthenticatedFlowsRoute: AuthenticatedFlowsRouteWithChildren,
  AuthenticatedIntegrationsRoute: AuthenticatedIntegrationsRouteWithChildren,
  AuthenticatedMessagesRoute: AuthenticatedMessagesRoute,
  AuthenticatedModelsRoute: AuthenticatedModelsRouteWithChildren,
  AuthenticatedProcessesRoute: AuthenticatedProcessesRouteWithChildren,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedTestHooksUseQueryParamsRoute:
    AuthenticatedTestHooksUseQueryParamsRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PluginsOutlookOutlookAuthOutlookSetupRouteChildren {
  PluginsOutlookOutlookAuthOutlookSetupEnableMfaRoute: typeof PluginsOutlookOutlookAuthOutlookSetupEnableMfaRoute
  PluginsOutlookOutlookAuthOutlookSetupLinkAccountRoute: typeof PluginsOutlookOutlookAuthOutlookSetupLinkAccountRoute
  PluginsOutlookOutlookAuthOutlookSetupNoAccessRoute: typeof PluginsOutlookOutlookAuthOutlookSetupNoAccessRoute
  PluginsOutlookOutlookAuthOutlookSetupNoMemberRoute: typeof PluginsOutlookOutlookAuthOutlookSetupNoMemberRoute
  PluginsOutlookOutlookAuthOutlookSetupNoOrgRoute: typeof PluginsOutlookOutlookAuthOutlookSetupNoOrgRoute
  PluginsOutlookOutlookAuthOutlookSetupVerifyEmailRoute: typeof PluginsOutlookOutlookAuthOutlookSetupVerifyEmailRoute
}

const PluginsOutlookOutlookAuthOutlookSetupRouteChildren: PluginsOutlookOutlookAuthOutlookSetupRouteChildren =
  {
    PluginsOutlookOutlookAuthOutlookSetupEnableMfaRoute:
      PluginsOutlookOutlookAuthOutlookSetupEnableMfaRoute,
    PluginsOutlookOutlookAuthOutlookSetupLinkAccountRoute:
      PluginsOutlookOutlookAuthOutlookSetupLinkAccountRoute,
    PluginsOutlookOutlookAuthOutlookSetupNoAccessRoute:
      PluginsOutlookOutlookAuthOutlookSetupNoAccessRoute,
    PluginsOutlookOutlookAuthOutlookSetupNoMemberRoute:
      PluginsOutlookOutlookAuthOutlookSetupNoMemberRoute,
    PluginsOutlookOutlookAuthOutlookSetupNoOrgRoute:
      PluginsOutlookOutlookAuthOutlookSetupNoOrgRoute,
    PluginsOutlookOutlookAuthOutlookSetupVerifyEmailRoute:
      PluginsOutlookOutlookAuthOutlookSetupVerifyEmailRoute,
  }

const PluginsOutlookOutlookAuthOutlookSetupRouteWithChildren =
  PluginsOutlookOutlookAuthOutlookSetupRoute._addFileChildren(
    PluginsOutlookOutlookAuthOutlookSetupRouteChildren,
  )

interface PluginsOutlookOutlookAuthRouteChildren {
  PluginsOutlookOutlookAuthOutlookSetupRoute: typeof PluginsOutlookOutlookAuthOutlookSetupRouteWithChildren
  PluginsOutlookOutlookAuthAuthErrorRoute: typeof PluginsOutlookOutlookAuthAuthErrorRoute
  PluginsOutlookOutlookAuthLoginRoute: typeof PluginsOutlookOutlookAuthLoginRoute
}

const PluginsOutlookOutlookAuthRouteChildren: PluginsOutlookOutlookAuthRouteChildren =
  {
    PluginsOutlookOutlookAuthOutlookSetupRoute:
      PluginsOutlookOutlookAuthOutlookSetupRouteWithChildren,
    PluginsOutlookOutlookAuthAuthErrorRoute:
      PluginsOutlookOutlookAuthAuthErrorRoute,
    PluginsOutlookOutlookAuthLoginRoute: PluginsOutlookOutlookAuthLoginRoute,
  }

const PluginsOutlookOutlookAuthRouteWithChildren =
  PluginsOutlookOutlookAuthRoute._addFileChildren(
    PluginsOutlookOutlookAuthRouteChildren,
  )

interface PluginsOutlookTaskpaneRouteChildren {
  PluginsOutlookTaskpaneShowFileRoute: typeof PluginsOutlookTaskpaneShowFileRoute
  PluginsOutlookTaskpaneIndexRoute: typeof PluginsOutlookTaskpaneIndexRoute
}

const PluginsOutlookTaskpaneRouteChildren: PluginsOutlookTaskpaneRouteChildren =
  {
    PluginsOutlookTaskpaneShowFileRoute: PluginsOutlookTaskpaneShowFileRoute,
    PluginsOutlookTaskpaneIndexRoute: PluginsOutlookTaskpaneIndexRoute,
  }

const PluginsOutlookTaskpaneRouteWithChildren =
  PluginsOutlookTaskpaneRoute._addFileChildren(
    PluginsOutlookTaskpaneRouteChildren,
  )

interface PluginsOutlookRouteChildren {
  PluginsOutlookOutlookAuthRoute: typeof PluginsOutlookOutlookAuthRouteWithChildren
  PluginsOutlookDialogRoute: typeof PluginsOutlookDialogRoute
  PluginsOutlookTaskpaneRoute: typeof PluginsOutlookTaskpaneRouteWithChildren
}

const PluginsOutlookRouteChildren: PluginsOutlookRouteChildren = {
  PluginsOutlookOutlookAuthRoute: PluginsOutlookOutlookAuthRouteWithChildren,
  PluginsOutlookDialogRoute: PluginsOutlookDialogRoute,
  PluginsOutlookTaskpaneRoute: PluginsOutlookTaskpaneRouteWithChildren,
}

const PluginsOutlookRouteWithChildren = PluginsOutlookRoute._addFileChildren(
  PluginsOutlookRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PluginsOutlookRoute: PluginsOutlookRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
